// extracted by mini-css-extract-plugin
module.exports = {"navbar-deadline":"src-_components-___Navigation-module__navbar-deadline___2KJbY","logo":"src-_components-___Navigation-module__logo___2OsgT"};